<h4 mat-dialog-title>Nueva funcionalidad</h4>
<div>
  <p>
    Te presentamos la nueva funcionalidad que hemos desarrollado para ti.
  </p>
  <p>
    A partir de ahora, toda la información de tus movimientos la encontrarás en <strong>“INFORMES”</strong> que se encuentra en el menú superior.
  </p>
</div>
<div align="end">
  <button mat-button color="#F85F1F" (click)="goToBiuwer()">Accede aquí</button>
</div>